import moment from 'moment';

export const filterList = ({ data = [], filters, startDate, endDate, assocStores }) => {
  const allStores = assocStores.filter(store => store.id !== 0).map(item => item.id.toString());

  return data?.filter(item => {
    const filterStore =
      filters.store.length === 0
        ? allStores.includes(item?.activity_store_id?.toString())
        : filters.store.includes(item?.activity_store_id?.toString());
    const filterAssociate =
      filters.associate.length === 0 || filters.associate.includes(item?.activity_associate_id?.toString());

    // activity_date is stored as UTC (date-only or full timestamp)
    // Compare in UTC to match the UTC date boundaries from ReportSelectDate
    if (!item.activity_date) {
      return false; // Skip items without activity_date
    }
    const activityDateUTC = moment.utc(item.activity_date);
    if (!activityDateUTC.isValid()) {
      return false; // Skip items with invalid dates
    }
    const filterTimeSpan = activityDateUTC.isBetween(
      moment.utc(startDate).startOf('day'),
      moment.utc(endDate).endOf('day'),
      'day',
      '[]'
    );

    const filterAutomationType =
      filters.automationType.length === 0 || filters.automationType.includes(item.automationType);
    return filterStore && filterAssociate && filterTimeSpan && filterAutomationType;
  });
};
